<template>
  <div class="p-3 bg-black/30 border border-nera-border rounded-lg">
    <div class="flex justify-between items-center">
      <span class="text-xs uppercase tracking-wider text-nera-muted">Credits Balance</span>
      <span :class="['text-xl font-bold', amountColor]">${{ authStore.creditsBalanceDollars }}</span>
    </div>

    <div
      v-if="authStore.hasCriticalCredits"
      class="mt-2 px-2 py-1.5 rounded text-xs bg-nera-danger/10 border border-nera-danger/40 text-nera-text"
    >
      <strong class="text-nera-danger">Critical!</strong> Your credits are running low.
      <a href="/credits/purchase" class="text-nera-accent hover:text-nera-accent-hover underline underline-offset-2">Add credits</a>
    </div>

    <div
      v-else-if="authStore.hasLowCredits"
      class="mt-2 px-2 py-1.5 rounded text-xs bg-nera-warning/10 border border-nera-warning/40 text-nera-text"
    >
      Your credits are getting low.
      <a href="/credits/purchase" class="text-nera-accent hover:text-nera-accent-hover underline underline-offset-2">Add more</a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthStore } from '../stores/auth'

const authStore = useAuthStore()

const amountColor = computed(() => {
  if (authStore.hasCriticalCredits) return 'text-nera-danger'
  if (authStore.hasLowCredits) return 'text-nera-warning'
  return 'text-nera-success'
})
</script>
